import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import '../css/Login.css';
import { userResponseService } from '../../api/userapi';
import { NavbarBrand } from 'reactstrap';


class StripeSuccess extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
        this.toSignIn = this.toSignIn.bind(this);
    }

    componentDidMount() {
    }

    toSignIn() {
        this.props.userResponseConnect(null);
        this.props.route.history.push('/');
    }

    render() {
        return (
            <div>
                <div className="d-flex justify-content-center">
                    <NavbarBrand tag={Link} to="/"><img src="./aaa_logo.png" alt="logo" className="title-logo" /></NavbarBrand>
                </div>
                <div className="d-flex justify-content-center">
                    <h5 className="title-login-logo"> GIFT CENTER PORTAL </h5>
                </div>


                <div className="text-center user-text">
                    <p className="title-stripe-success">Congratulations! Your Stripe account is now connected AAA Gift Center.</p>
                </div>
                <br></br>
                <div className="text-center user-text">
                    <div className="d-flex justify-content-center">
                        <button className="btn mt-4 stripe" onClick={this.toSignIn}>SIGN IN</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    state => {
        return {
        }
    },
    dispatch => ({
        userResponseConnect: (response) => { dispatch(userResponseService(response)) }
    })
)(StripeSuccess);